import {useTranslation} from "react-i18next";
import "moment-timezone";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableOperationsMode = ({items, itemsShow, buttonsTB, setButtonsTB, checkAll, setCheckAll, orderingRef}) => {
    const {t: _Tc} = useTranslation("choices");
    const {t: _Tt} = useTranslation("tables");
    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const stickyCellStyle = {
        position: "sticky",
        top: "164px",
        backgroundColor: "white",
        zIndex: 899,
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "169px",
        backgroundColor: "white",
        zIndex: 899,
    };

    return (
        <table className="table table-striped sticky-horizontal">
            <thead>
                <tr>
                    <th
                        key="-1"
                        className="sticky-top border-bottom-sticky "
                        style={{
                            width: "32px",
                            verticalAlign: "bottom",
                            ...stickyCellStyle,
                        }}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                    <th
                        className="sticky-top border-bottom-sticky "
                        style={{
                            width: "10%",
                            verticalAlign: "bottom",
                            ...stickyCellStyle,
                        }}>
                        {_Tt("deviceModes.interval_type")}
                    </th>
                    <th
                        className="text-center sticky-top border-bottom-sticky "
                        style={{
                            width: "10%",
                            verticalAlign: "bottom",
                            ...stickyCellStyle,
                        }}>
                        {_Tt("deviceModes.h_start")}
                    </th>
                    <th
                        className="text-center sticky-top border-bottom-sticky "
                        style={{
                            width: "10%",
                            verticalAlign: "bottom",
                            ...stickyCellStyle,
                        }}>
                        {_Tt("deviceModes.num_pub")}
                    </th>

                    <th
                        className="text-center sticky-top border-bottom-sticky "
                        style={{
                            width: "10%",
                            verticalAlign: "bottom",
                            ...stickyCellStyle,
                        }}>
                        {_Tt("deviceModes.min_measure")}
                    </th>
                    <th
                        className="text-center  sticky-top border-bottom-sticky "
                        style={{
                            width: "10%",
                            verticalAlign: "bottom",
                            ...stickyCellStyle,
                        }}>
                        {_Tt("deviceModes.num_measure")}
                    </th>
                    <th
                        className="text-center sticky-top border-bottom-sticky "
                        style={{
                            width: "10%",
                            verticalAlign: "bottom",
                            ...stickyCellStyle,
                        }}>
                        {_Tt("deviceModes.min_measure_b")}
                    </th>
                </tr>
            </thead>
            <tbody>
                {itemsShow.map((item) => (
                    <tr key={item.id} data-idx={item.id} onClick={onClick}>
                        <td>
                            <input
                                type="checkbox"
                                name="checkboxOpModes"
                                key={item.id}
                                data-idx={item.id}
                                defaultChecked={items.current.chosen.includes(item.id)}
                                readOnly={true}
                            />
                        </td>
                        <td>{item.name}</td>
                        <td>{item.model}</td>
                        <td>{_Tc("interval_type." + item.interval_type)}</td>

                        <td className="text-center">{item.values.h_start ?? ""}</td>
                        <td className="text-center">{item.values.num_pub ?? "-"}</td>
                        <td className="text-center">{item.values.min_measure ?? ""}</td>
                        <td className="text-center">{item.values?.num_measure || "-"}</td>
                        <td className="text-center">{item.values?.min_measure_b || "-"}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableOperationsMode;
